<template>
    <tabs parent="tariffication" v-if="show_page">
        <tab
            id="tariffed_devices"
            :name="translate('tariffication.tariffed_devices')"
            :href="url+'tariffed_devices?&tariffed=1'"
        >
            <TariffedDevices :tariffs="tariff_list" />
        </tab>

        <tab
            id="tariff_list"
            :name="translate('tariffication.tariff_list')"
            :href="url+'tariff_list?&with_devices=1'"
        >
            <TariffList :tariff_filter="tariff_filter" @update="get_tariff_list"/>
        </tab>

        <tab
            id="contract_list"
            :name="translate('tariffication.contract_list')"
            :href="url+'contract_list'"
            v-if="permission_commerce_god"
        >
          <ContractList />
        </tab>

        <tab
            id="services"
            :name="translate('tariffication.services')"
            :href="url+'services'"
            v-if="permission_commerce_god"
        >
            <Services />
        </tab>
    </tabs>

    <div v-else style="height: 100%" >
        <div class="spinner">
            <scale-loader />
        </div>
    </div>
</template>

<script>

import {Tabs, Tab} from 'components/UIComponents/Tabs'
import TariffedDevices from "./Tabs/TariffedDevices/Index.vue";
import TariffList from "./Tabs/TarrifList/Index.vue";
import ContractList from "./Tabs/ContractList/Index.vue";
import Services from "./Tabs/Services/Index.vue";

export default {
    name: 'Tariffication',
    components:{
        Tab,
        Tabs,
        TariffedDevices,
        TariffList,
        ContractList,
        Services
    },
    props: {
    },
    data () {
      return {
          tariff_list: {},
          show_page: false,
          tariff_filter: {}
      }
    },
    computed: {
      url () { return '/tariffication/' },
      permission_commerce_god(){
        return this.$store.getters.getPermissions.permissionCommerceGod === true
      },
    },

    created () {
        this.get_tariff_list()
    },

    methods: {
        get_tariff_list(){
            this.$http.v1.getTariffList({}, (response) => {
                this.tariff_list = response.data
                this.show_page = true
            })
        },
    },
}
</script>
